export const getLauncherOpen = (state) => state.launcher.get("isModalOpen");

export const getpreselectedFundExId = (state) =>
  state.launcher ? state.launcher.get("preselectedFundExId") : false;

export const getPrepopulateAmount = (state) =>
  state.launcher ? state.launcher.get("prepopulateAmount") : false;
